declare global {
    interface Window { dataLayer: any[]; Digidom: any; }
}

// Libs
import './../../node_modules/mmenu-light/dist/mmenu-light';
import './../../node_modules/glider-js/glider.min';

// Polyfill
import './blocks';

// Logic
import './nav';
import './digidom/cookie-consent';
import './digidom/form';
import './digidom/glider';